export const SERVICE_NAME = "supportfrontend";

export const COPILOT_CONVERSATION_PROXY_ROUTE =
  "/api/supportfrontend/v1/proxy/copilot-conversation";
